{
  "Özlük": "Persoonsgegevens",
  "ozluk": {
    "Personel Tanımınız Yok": "Geen Personeelsdefinitie",
    "Özlük": "Persoonsgegevens",
    "Güncelleme başarılı": "Güncelleme başarılı"
  }
}
